export const PROMO_CATEGORIES = [
  "Confectionery",
  "Liquor",
  "Tobacco",
  "Perfumes",
  "Cosmetics",
  "Electronics",
  "Watches",
  "Sunglasses",
  "Gold",
  "Pens",
  "Lighters",
  "Pharmacy",
  "Fashion",
  "Luggage",
  "Toys",
  "Gifts From Dubai",
  "Lifestyle",
  "Sports",
  "Personal Care",
  "Travel Accessories",
  "Books",
  "Magazines",
  "Cigarettes",
  "Delicatessen",
];
